<template src="./vehicleinspections.html"></template>
<script>
  import VueGallery from "vue-gallery";
  import Axios from "axios";
  import $ from "jquery";
  var moment = require("moment");

  export default {
    components: {
      VueGallery,
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
    },
    data() {
      return {
        basic: {
          currentPage: 1,
          totalPages: 0,
        },

        VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        ShowLoader: false,
        SearchKey: "",
        fromDate: "",
        toDate: "",
        vrm: "",
        VehicleInspections: [],
        MarkingCodes: [],
        VehicleNotes: "",
        ShowVehicleInspectionImageModel: false,
        ShowSubmitVehicleInspectionModel: false,
        isMechanicAttached: true,
        ShowVehicleNotesModel: false,
        UniqueUrl: "",
        Mechanics: [],
        Vehicle: "",
        Mechanic: "",
        Vehicles: [],
        ShowVehicleNotesModelHeading: "Notes",
        excel_data: [],
        lightgallery: [],
        biglightgallery: [],
        gindex: 1,
        MileageUnit: "Mileage",
        galleryoptions: {
          prevClass: "prev",
          nextClass: "next",
        },
        driver: "",
        vehicle_class: 0,
        VehicleClass: "",
        ShowGenerateURL: false,
        ShowEmailLoader: false,
      };
    },
    watch: {
      "$route.query": {
        handler: function () {
          this.vehicle_class = this.$route.params.VehicleClassID;
          this.GetCompanySubscription();
        },
        deep: true,
      },
    },
    mounted() {
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );

      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions["HGV"] || !AccountPermissions["HGV"]["enable"])
      ) {
        this.$router.push("/");
      }
      if (
        AccountPermissions &&
        AccountPermissions["HGV"] &&
        AccountPermissions["HGV"]["enable"]
      ) {
        if (AccountPermissions["HGV"]["generate_inspection"]) {
          this.ShowGenerateURL = true;
        }
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowGenerateURL = true;
      }

      document.title = pbx_SiteTitle + " - Vehicles Inspections";
      this.vehicle_class = this.$route.params.VehicleClassID;
      this.GetCompanySubscription();

      var Company = JSON.parse(localStorage.getItem("Company"));
      if (CompanyData && Company.mileage_unit == 2) {
        this.MileageUnit = "KM";
      }
    },

    methods: {
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isHGV = FleetSubscriptionModules.HGV;
        if (isHGV) {
          this.GetVehicleInspectionsList();
        } else {
          this.$router.push("/");
        }
      },
      generateUrlPopup() {
        this.Mechanic = "";
        this.Vehicle = "";
        this.GetMechanics();
        this.GetVehicles();
        this.ShowSubmitVehicleInspectionModel = true;
        this.isMechanicAttached = false;
        this.UniqueUrl = "";
      },
      GetMechanics() {
        var obj = { token: localStorage.getItem("token") };
        Axios.post(Endpoints.VehicleInspections.GetMechanics, obj).then(
          (Response) => {
            this.ShowLoader = false;
            if (Response?.data?.success) {
              this.Mechanics = Response.data.mechanics;
            }
          }
        );
      },
      GetVehicles() {
        var obj = { token: localStorage.getItem("token") };
        obj.vehicle_class = this.VehicleClass;
        Axios.post(Endpoints.VehicleInspections.GetVehicles, obj).then(
          (Response) => {
            if (Response?.data?.success) {
              this.Vehicles = Response.data.vehicles;
            }
          }
        );
      },
      generateUrl() {
        var obj = { token: localStorage.getItem("token") };
        obj.vehicle_id = this.Vehicle;
        obj.mechanic_id = this.Mechanic;
        obj.vehicle_class = this.vehicle_class;
        Axios.post(Endpoints.VehicleInspections.GenerateURL, obj).then(
          (Response) => {
            this.ShowLoader = false;
            if (Response?.data?.success) {
              var uniqueUrl = Response.data.uniqueUrl;
              this.UniqueUrl =
                window.location.origin +
                "/create-vehicle-inspection/" +
                uniqueUrl;
              this.ShowSubmitVehicleInspectionModel = true;
              this.isMechanicAttached = true;
            } else {
              this.$swal
                .fire("Please select vehicle and mechanic", "", "error")
                .then(() => {});
            }
          }
        );
      },
      copy_text_input() {
        this.$refs.UniqueUrl.select();
        document.execCommand("copy");
        alert("copied");
      },
      sendInspectionURL() {
        this.ShowEmailLoader = true;
        var obj = { token: localStorage.getItem("token") };
        obj.unique_url = this.UniqueUrl;
        obj.mechanic_id = this.Mechanic;
        Axios.post(Endpoints.VehicleInspections.SendMail, obj).then(
          (Response) => {
            this.ShowEmailLoader = false;
            if (Response?.data?.success == true) {
              this.$swal.close();
              this.$swal
                .fire(
                  "Submit Inspection URL has been sent Successfully",
                  "",
                  "success"
                )
                .then(() => {
                  this.ShowSubmitVehicleInspectionModel = false;
                  this.isMechanicAttached = false;
                  this.UniqueUrl = "";
                });
            } else {
              this.$swal
                .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                .then(() => {});
            }
          }
        );
      },
      SearchVehicle() {
        this.GetVehicleInspectionsList("search");
      },
      GetVehicleInspectionsList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.vrm = this.vrm;
          obj.fromDate = this.fromDate;
          obj.toDate = this.toDate;
          obj.driver = this.driver;
        }
        this.ShowLoader = true;
        obj.vehicle_class = this.vehicle_class;
        Axios.post(Endpoints.VehicleInspections.InspectionsList, obj).then(
          (Response) => {
            this.ShowLoader = false;
            if (Response?.data?.success) {
              this.VehicleInspections = Response.data.records;
              this.MarkingCodes = Response.data.markingCodes;
              this.VehicleClass = Response.data.vehicleClass.title;
              this.SetVehicleInspectionsExcelData();
            }
          }
        );
      },
      SetVehicleInspectionsExcelData() {
        this.excel_data = [];
        this.VehicleInspections.forEach((element) => {
          var obj = {};
          obj["created_at"] = element.created_at;
          obj["vrm"] = element.vrm;
          obj["driver"] = element.driver_name;
          this.MarkingCodes.forEach((CompanyElement) => {
            obj[CompanyElement.title] = element[CompanyElement.title];
          });

          obj["inspection_result"] = element.final_result;

          obj["current_mileage"] = element.current_mileage;
          obj["notes"] = element.notes;
          this.excel_data.push(obj);
        });
      },
      ShowVehicleNotes(VehicleInspection, type = "notes") {
        if (VehicleInspection.notes != null && VehicleInspection.notes != "") {
          this.ShowVehicleNotesModel = true;
          this.VehicleNotes = VehicleInspection.notes;
          this.ShowVehicleNotesModelHeading = "Notes";
        }
      },
      ShowVehicleImage(VehicleInspection) {
        this.ShowVehicleInspectionImageModel = true;
        this.lightgallery = JSON.parse(JSON.stringify(VehicleInspection.photo));
        this.biglightgallery = JSON.parse(
          JSON.stringify(VehicleInspection.photo)
        );
        for (var i = 0; i < this.biglightgallery.length; i++) {
          this.biglightgallery[i] =
            this.ImageEndpoint + this.biglightgallery[i];
        }
      },
    },
  };
</script>
<style scoped>
.vehiclechecklist th:first-child,
  .vehiclechecklist th:nth-child(2) {
    background: #fff !important;
  }
  .vehiclechecklist th:first-child{
    min-width: 119px;
  }
  .vehiclechecklist th:first-child,
  .vehiclechecklist td:first-child,
  .vehiclechecklist th:nth-child(2),
  .vehiclechecklist td:nth-child(2),
  .vehiclechecklist th:nth-child(3),
  .vehiclechecklist td:nth-child(3) {
    position: sticky;
    left: -1px;
    background: #fff !important;
    z-index: 5;
  }
 .vehiclechecklist td:first-child,
 .vehiclechecklist td:nth-child(2),
  .vehiclechecklist td:nth-child(3) {
    position: sticky;
    left: -1px;
    background: #fff !important;
    z-index: 2;
  }
  .vehiclechecklist th:nth-child(2),
  .vehiclechecklist td:nth-child(2) {
    left: 119px;
    min-width: 110px !important;
  }
  .vehiclechecklist th:nth-child(3),
  .vehiclechecklist td:nth-child(3) {
    left: 229px;
    min-width: 150px !important;
  }
  .custom-scrollbar2 thead th {
    position: sticky;
    top: -1px;
    background: #FFF;
    z-index: 4;
}
  .datatable-vue table tbody tr:nth-child(odd) td {
    background-color: #f9f9f9 !important;
  }
  .datatable-vue table tbody tr:hover td {
    background-color: #f9f9f9 !important;
  }
</style>

<style type="text/css">
  .vehiclechecklist .btn {
    padding: 0.375rem 1.25rem;
  }
  .vehiclechecklist td.w120 {
    width: 120px !important;
    min-width: 120px !important;
  }
  .vehiclechecklist td.w100 {
    width: 100px !important;
    min-width: 100px !important;
  }
  .vehiclechecklist td.w80 {
    width: 80px !important;
    min-width: 80px !important;
  }
  .bg-disable {
    background-color: #ccc !important;
  }
  span.failicon {
    position: relative;
  }
  td.MarkingCodes .fixedbage {
    position: absolute;
    z-index: 1;
  }
  td.MarkingCodes {
    position: relative;
  }
  td.MarkingCodes span.btn {
    padding: 3px 8px;
  }
  td.MarkingCodes .dropdown .dropdown-toggle {
    padding: 0.375rem 1.75rem;
  }
  td.MarkingCodes .dropdown {
    margin-bottom: 0px !important;
  }
  .nosubmenu .dropdown-toggle::after {
    display: none;
  }
  .dropdown-basic .dropdown .dropdown-menu {
    z-index: 99 !important;
  }
  .VehicleInspectionPaging .page-item:last-child .page-link,
  .VehicleInspectionPaging .page-item:first-child .page-link {
    padding: 6px 6px 5px 6px;
  }
  .loaderIcon {
    display: inline-block !important;
    margin-left: 10px;
    width: auto;
  }
  @media screen and (max-width: 990px) {
    .search-data {
      width: 30%;
    }
    .d-flex.label-box {
      display: block !important;
      width: 100% !important;
    }

    .label-box span {
      width: 100% !important;
    }
    .searchregs {
      margin: 10px 0;
    }
  }
  @media screen and (max-width: 780px) {
    .search-data {
      width: 100%;
    }
  }
  @media (min-width: 762px) and (max-width: 1180px) {
    .vehicle-checks .col-xl-3,
    .vehicle-checks .col-xl-2 {
      max-width: 25%;
    }
    .vehicle-checks .col-xl-3 .searchregs {
      margin-top: 17px;
    }
    .search-data {
      margin-top: 17px;
      min-width: 100%;
    }
  }
  @media (min-width: 1180px) and (max-width: 1379px) {
    .vehicle-checks .col-xl-3,
    .vehicle-checks .col-xl-2 {
      max-width: 25%;
    }
    .vehicle-checks .col-xl-3 .searchregs {
      margin-top: 0;
    }
    .search-data {
      margin-top: 0;
      min-width: 100%;
    }
  }
</style>
